import React from 'react'

import "./NotFound.css"
import { Link } from 'react-router-dom';
import { useLanguage } from '../Context/LanguageContext';

const NotFound = () => {
    const {ForRegular, ForChina} = useLanguage()

    return ( 
        <>
            <ForRegular>
                <section className='not-found'>
                    <h1>404</h1>
                    <h2>Es ist ein Fehler aufgetreten</h2>
                    <p>Die angegebene Seite konnte nicht gefunden werden.</p>
                    <Link to="/"><span>←</span> Startseite</Link>
                </section>
            </ForRegular>
            
            <ForChina>
                <section className='not-found'>
                    <h1>404</h1>
                    <h2>发生错误</h2>
                    <p>找不到指定页面</p>
                    <Link to="/"><span>←</span> 主页</Link>
                </section>
            </ForChina>
        </>
     );
}
 
export default NotFound;